import { Injectable } from '@angular/core';
import { HttpClient } from './http-client';
import { BaseEntityService } from './baseentity-service';
import { Response } from '@angular/http';
import * as moment from 'moment';

@Injectable()
export class FinancieraService extends BaseEntityService {
  constructor(httpClient: HttpClient) {
    super(httpClient);
  }

  responseItemToEntity(responseItem: any): any {
    return {
      ID: responseItem.EntidadFinanciera.ID,
      Nombre: responseItem.EntidadFinanciera.Nombre,
      Descripcion: responseItem.EntidadFinanciera.Descripcion,
      FechaCreacion: responseItem.EntidadFinanciera.FechaCreacion,
      Creador: responseItem.EntidadFinanciera.Creador,
      Subentidades: responseItem.SubentidadesFinancieras
    };
  }

  apiRoute: string = '/api/precio/entidades-financieras';

  // enviar a validacion los precios de Financiera
  crearPreciosFinanciera(precios) {
    return this.httpClient.post(`/api/precio/cotizacion`, precios)
      .map((response: Response) => {
        return response.json().ResponseData;
      });
  }

  // obtener los precios a validar de Financiera
  getPreciosValidar() {
    return this.httpClient.get(`/api/precio/cotizacion/validador`)
      .map((response: Response) => {
        return response.json().ResponseData;
      });
  }

  publicarPrecios(precios) {
    return this.httpClient.post(`/api/precio/cotizacion/publish`, precios)
    .map((response: Response) => {
      return response.json().ResponseData;
    });
  }

  // obtener los precios de monitor
  getPreciosMonitor() {
    return this.httpClient.get(`/api/precio/cotizacion/monitor`)
      .map((response: Response) => {
        return response.json().ResponseData;
      });
  }

  rechazarPrecio(precioId: number) {
    return this.httpClient.post(`/api/precio/cotizacion/rechazar/${precioId}`, {})
      .map((response: Response) => {
        return response.json().ResponseData;
      });
  }

  getPreciosGrilla(filter) {
    const payload = {
      PageSize: 30,
      PageNumber: filter.page,
      AscendingOrder: filter.AscendingOrder,
      ColumnOrder: filter.ColumnOrder,
      FromDate: filter.marcaTemporalDesde !== null ? moment(moment(filter.marcaTemporalDesde).startOf('day').toDate()).unix() : null,
      ToDate: filter.marcaTemporalHasta !== null ? moment(moment(filter.marcaTemporalHasta).endOf('day').toDate()).unix() : null,
      FilterCreador: filter.creador.map(x => x.Id),
      FilterValidador: filter.validador.map(x => x.Id),
      CotizacionFromDate: filter.fechaCreacionDesde !== null ? moment(moment(filter.fechaCreacionDesde).startOf('day').toDate()).unix() : null,
      CotizacionToDate: filter.fechaCreacionHasta !== null ? moment(moment(filter.fechaCreacionHasta).endOf('day').toDate()).unix() : null,
      EntFinancierasIds: filter.entidad.map(x => x.Id),
      SubentFinancierasIds: filter.subentidad.map(x => x.Id),
    };
    return this.httpClient.post(`/api/precio/cotizacion/grilla`, payload)
      .map((response: Response) => {
        return response.json().ResponseData;
      });
  }

  crearEntidad(payload: any) {
    return this.httpClient.post(`/api/precio/entidades-financieras`, payload)
      .map((response: Response) => {
        return response.json().ResponseData;
      });
  }

  editarEntidad(payload: any) {
    return this.httpClient.put(`/api/precio/entidades-financieras`, payload)
      .map((response: Response) => {
        return response.json().ResponseData;
      });
  }

  toggleEntidadVisibilidad(entidadId) {
    return this.httpClient.get(`/api/precio/entidades-financieras-visibilidad/${entidadId}`)
      .map((response: Response) => {
        return response.json().ResponseData;
      });
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/services/financiera-service.ts